module.exports = __webpack_public_path__ + "static/media/step2-results-and-recommendations.f245db6d.png";